unable to read source [project]/packages/mobile/node_modules/@finbackoffice/fe-core/src/constants/transactions.ts